"use client";

import * as React from "react";
import {
  SidebarMenu,
  SidebarMenuItem,
  useSidebar,
} from "@focal/ui-kit";
import Image from "next/image";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { routes } from "@/constants";
import { Button } from "@focal/ui-kit";
import { MenuIcon, MenuOpenIcon } from "@focal/ui-kit";
export function NavHeader() {
  const { toggleSidebar, open, openMobile, isMobile } = useSidebar();
  // `open` only tracks the desktop sidebar. On mobile the sheet uses
  // `openMobile`, so without this branch the mobile sheet would render the
  // collapsed (icon-only) header and hide the logo.
  const isExpanded = isMobile ? openMobile : open;

  return (
    <SidebarMenu className="mb-5">
      <SidebarMenuItem
        className={cn(
          "flex flex-row !justify-between w-full items-center pl-4",
          !isExpanded && "!justify-center !pl-0",
        )}
      >
        {isExpanded && (
          <Link
            href={routes.home.index}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <Image
              src={"/assets/logo-text.svg"}
              alt="focal"
              width={82}
              height={23}
            />
          </Link>
        )}
        <Button
          variant={"ghost"}
          onClick={toggleSidebar}
          size="sm"
          className="p-1 text-center group"
        >
          {isExpanded ? (
            <MenuOpenIcon
              alt="menu"
              width={24}
              height={24}
              className="text-base fill-primary"
            />
          ) : (
            <MenuIcon
              alt="menu"
              width={24}
              height={24}
              className="fill-primary"
            />
          )}
        </Button>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
